/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `record_activity` - Záznam aktivita * `record_touch` - Záznam dotek * `skill` - Dovednost * `competence` - Kompetence * `literacy` - Gramotnost * `note` - Poznámka * `file` - Soubor * `other` - Jiné
 */
export type KindEnum = 'record_activity' | 'record_touch' | 'skill' | 'competence' | 'literacy' | 'note' | 'file' | 'other';

export const KindEnum = {
    RecordActivity: 'record_activity' as KindEnum,
    RecordTouch: 'record_touch' as KindEnum,
    Skill: 'skill' as KindEnum,
    Competence: 'competence' as KindEnum,
    Literacy: 'literacy' as KindEnum,
    Note: 'note' as KindEnum,
    File: 'file' as KindEnum,
    Other: 'other' as KindEnum
};